class PerDaysProductSalesTargets{
    constructor({unitSold=null, baseSales=null, baseProfit=null,}={}){
        //TODO Implement
    }

}

export { PerDaysProductSalesTargets };